import { Alert } from '@mui/material';
import { useEffect, useState } from "react";
import MDTypography from "components/MDTypography";
import MDBox from 'components/MDBox';

function CustomAlert(props) {

  const { severity, message, open, onClose } = props;

  return (
    <MDBox>
      {open && (
        <Alert variant="filled" severity={severity} onClose={onClose} >
          <MDTypography variant="body2" color="white">
            {message}
          </MDTypography>
        </Alert>
      )}
    </MDBox>
  );
}

export default CustomAlert;